import React from 'react';
import styled from 'styled-components';
import Stars from '../../../components/stars';
import TotalMaximumScore, { TotalScore, MaximumScore } from '../../../components/total-maximum-score';

const Rating = ({ className, ratingIds }) => (
  <div className={className}>
    <TotalMaximumScore
      ratingIds={ratingIds}
      css={`
        ${TotalScore} {
          font-size: 1.25rem;
        }
        ${MaximumScore} {
          font-size: 1rem;
        }
      `}
    />
    <Stars ratingIds={ratingIds} />
  </div>
);

export default styled(Rating)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
